(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  var link = document.getElementById("support");

  if (window.innerWidth >= 768) {
    link.removeAttribute("href"); 
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
if (!customElements.get('article-template-filter')) {
  class ArticleTemplateFilter extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.buttons = this.querySelectorAll('[data-article-template-filter]');
      const requestedFilter = new URL(window.location.href).searchParams.get('blog-template-filter');
      this.activeFilter = requestedFilter === 'video-blogs' || requestedFilter === 'guides'
        ? requestedFilter
        : this.dataset.defaultFilter;
      this.handleClick = this.handleClick.bind(this);
      this.observeResults = this.observeResults.bind(this);

      this.buttons.forEach((button) => button.addEventListener('click', this.handleClick));
      this.observeResults();
      this.applyFilter();
    }

    disconnectedCallback() {
      this.buttons.forEach((button) => button.removeEventListener('click', this.handleClick));
      if (this.resultsObserver) this.resultsObserver.disconnect();
    }

    handleClick(event) {
      const selectedFilter = event.currentTarget.dataset.articleTemplateFilter;
      if (selectedFilter === this.activeFilter) return;

      const url = new URL(window.location.href);
      url.searchParams.delete('page');
      url.searchParams.set('blog-template-filter', selectedFilter);
      window.location.assign(url.toString());
    }

    observeResults() {
      this.pagination = document.querySelector(`custom-pagination [data-blog-section="${this.sectionId}"]`)?.closest('custom-pagination');
      if (!this.pagination) return;

      this.resultsObserver = new MutationObserver(() => this.applyFilter());
      this.resultsObserver.observe(this.pagination, { childList: true, subtree: true });
    }

    applyFilter() {
      const selector = `[data-blog-template-item][data-blog-section="${this.sectionId}"]`;
      document.querySelectorAll(selector).forEach((item) => {
        item.hidden = item.dataset.articleTemplate !== this.activeFilter;
      });

      this.updatePagination();

      this.buttons.forEach((button) => {
        const isActive = button.dataset.articleTemplateFilter === this.activeFilter;
        button.classList.toggle('btn--primary', isActive);
        button.classList.toggle('btn--secondary', !isActive);
        button.setAttribute('aria-pressed', isActive);
      });
    }

    updatePagination() {
      if (!this.pagination) return;

      const resultCount = this.activeFilter === 'video-blogs'
        ? Number(this.dataset.videoBlogCount)
        : Number(this.dataset.guidesCount);
      const hasMultiplePages = resultCount > Number(this.dataset.postsPerPage);
      const paginationNav = this.pagination.querySelector('.js-pagination')?.closest('nav');

      if (paginationNav) paginationNav.hidden = !hasMultiplePages;
      this.pagination.querySelectorAll('.js-when-paginated-only').forEach((element) => {
        element.hidden = !hasMultiplePages;
      });
    }
  }

  customElements.define('article-template-filter', ArticleTemplateFilter);
}

  } catch(e) { console.error(e); }
})();
})();
